/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgKeys56(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={56}
      height={56}
      fill='none'
      viewBox='0 0 56 56'
      {...props}
    >
      <path
        fill='currentColor'
        fillRule='evenodd'
        d='M15.826 8a3.375 3.375 0 110 6.75 3.375 3.375 0 010-6.75zm1.875 3.375a1.875 1.875 0 10-3.75 0 1.875 1.875 0 003.75 0z'
      />
      <path
        fill='currentColor'
        fillRule='evenodd'
        d='M15.826 2.75c6.697 0 12.125 5.429 12.125 12.125 0 4.865-2.865 9.06-7 10.992v23.387l-5.125 4.217-5.125-4.217v-4.258l3.204-3.296-3.204-3.296v-4.209l1.454-1.495-1.454-1.496v-5.337c-4.134-1.931-7-6.127-7-10.992C3.701 8.179 9.13 2.75 15.826 2.75zm10.625 12.125c0-5.868-4.757-10.625-10.625-10.625S5.201 9.007 5.201 14.875 9.958 25.5 15.826 25.5s10.625-4.757 10.625-10.625zm-7 33.67V26.45a12.119 12.119 0 01-3.625.551c-1.262 0-2.48-.193-3.625-.551v4.146l2.046 2.105-2.046 2.104v2.991l3.796 3.905-3.796 3.904v2.942l3.625 2.983 3.625-2.983z'
      />
      <path
        fill='currentColor'
        fillRule='evenodd'
        d='M37.623 11.346a10.607 10.607 0 00-7.89-5.232l.187-1.489a12.108 12.108 0 019.002 5.97c2.433 4.214 2.05 9.28-.566 13.02L50.103 43.96l-2.388 6.113-6.489-.988-2.085-3.612 1.167-4.357-4.357-1.167-2.06-3.57.526-1.966-1.966-.527-2.972-5.147a12.138 12.138 0 01-3.291-.164l.277-1.474a10.58 10.58 0 007.27-1.242c5.081-2.934 6.822-9.432 3.888-14.514zm10.82 32.74L37.349 24.87a12.126 12.126 0 01-2.864 2.29 12.123 12.123 0 01-3.415 1.335l2.37 4.105 2.816.755-.755 2.815 1.44 2.492 5.205 1.395-1.395 5.206 1.415 2.45 4.59.699 1.688-4.324z'
      />
    </svg>
  );
}

export default SvgKeys56;
